import WorkersCompTab from "../../../../patient/details/workersComp/WorkersCompTab";

export default function WorkersCompDrawerTab({classes, goToCaseTabHandler, column = 5, inWorkQ}) {
    return <div className={`${classes.block} ${classes[`block_${column}`]}`}>
        <WorkersCompTab inWorkQ={inWorkQ} />
    </div>
}
